import { EmptyControl, HvlBaseModel } from '@hvlng/framework-bff/core';
import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('FileDownloadModel')
export class FileDownloadModel extends HvlBaseModel {
    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('contentType', String, true)
    contentType: string = null;

    @EmptyControl()
    @JsonProperty('content', Any, true)
    content: any[] = null;
}
